export const queueAgentStates = Object.freeze({
  RING: 'RING',
  RINGING: 'RINGING',
  PAUSE: 'PAUSE',
  AVAILABLE: 'AVAILABLE',
  UNPLACED: 'UNPLACED',
  TABULATION_PAUSE: 'TABULATION_PAUSE'
});
